import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ar from "./ar";

// Natural-language keys: `en` is an identity map of every ar key so interpolation works in both
// languages; any key missing from `ar` falls back to English gracefully.
const en = Object.fromEntries(Object.keys(ar).map((k) => [k, k]));

const saved = (typeof window !== "undefined" && localStorage.getItem("europcar_lang")) || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: saved,
  fallbackLng: "en",
  keySeparator: false,
  nsSeparator: false,
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export default i18n;
